import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';
import PAGE_COMPONENT from './UserTermsConditions';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);

/**
 *  To render the component:
 *
 *  req.reactRender = {
 *      componentPath: 'TermsConditions/UserTermsConditions/UserTermsConditions,
 *      props: {},
 *      metaTagData:{}
 *  }
 *
 *  next();
 *  return;
 *
 */
